<template>
  <div>
    <v-data-table
      :loading="loadingTable"
      :headers="headers"
      :items="users"
      sort-by="calories"
      class="elevation-1"
      :page-count="numberOfPagesPaginate"
      :page="currentPagePaginate"
      :server-items-length="totalStagesPaginate"
      :options.sync="options"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Usuários</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                rounded
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>
                  {{ icons.mdiPlus }}
                </v-icon>
                Novo Usuário
              </v-btn>
            </template>
            <v-card>
              <div class="title_body">
                <span class="text_title">{{ formTitle }}</span>
                <span class="btn_close"><v-btn
                  icon
                  small
                  @click="dialog = false"
                ><v-icon dark> {{ icons.mdiClose }}
                </v-icon></v-btn> </span>
              </div>

              <v-card-text>
                <v-container>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.name"
                        outlined
                        label="Nome"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.email"
                        outlined
                        label="Email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="editedItem.role_id"
                        :items="itemsRoles"
                        item-text="name"
                        item-value="id"
                        label="Perfil"
                        outlined
                      ></v-select>
                      <!-- <v-text-field
                        v-model="editedItem.role_id"
                        outlined
                        label="Perfil"
                      ></v-text-field> -->
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.password"
                        :type="showPassword ? 'text' : 'password'"
                        :append-icon="showPassword ? icons.mdiEye : icons.mdiEyeOff"
                        outlined
                        label="Senha"
                        autocomplete="new-password"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.password_confirmation"
                        :type="showPasswordConfirmation ? 'text' : 'password'"
                        :append-icon="showPasswordConfirmation ? icons.mdiEye : icons.mdiEyeOff"
                        outlined
                        label="Repetir Senha"
                        autocomplete="new-password"
                        @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Fechar
                </v-btn>
                <v-btn
                  :loading="loading"
                  color="primary"
                  @click="save"
                >
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          color="primary"
          class="mr-2"
          @click="editItem(item)"
        >
          {{ icons.mdiPencilOutline }}
        </v-icon>
        <v-icon
          color="error"
          @click="deleteItem(item)"
        >
          {{ icons.mdiDeleteOutline }}
        </v-icon>
      </template>
      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>
    <MsgDelete
      v-model="dialogDelete"
      @delete-yes="deleteItemConfirm()"
    />
  </div>
</template>

<script>
import {
  mdiClose, mdiDeleteOutline, mdiPencilOutline, mdiPlus, mdiEye, mdiEyeOff,
} from '@mdi/js'
import { mapActions } from 'vuex'
import MsgDelete from '@/components/MsgDelete.vue'
import NoDataTable from '@/components/NoDataTable.vue'

export default {
  components: {
    MsgDelete,
    NoDataTable,
  },
  data: () => ({
    itemsRoles: [],
    loadingTable: false,
    totalStagesPaginate: 0,
    numberOfPagesPaginate: 0,
    currentPagePaginate: 0,
    dialogDelete: false,
    dialog: false,
    loading: false,
    showPassword: false,
    showPasswordConfirmation: false,
    headers: [
      {
        text: 'ID',
        align: 'start',
        value: 'id',
      },
      { text: 'NOME', value: 'name' },
      { text: 'EMAIL', value: 'email' },
      { text: 'PERFIL', value: 'role.name' },

      {
        text: '',
        align: 'end',
        value: 'actions',
        sortable: false,
      },
    ],
    users: [],
    editedIndex: -1,
    editedItem: {
      name: '',
    },
    defaultItem: {
      name: '',
    },
    options: {},
    icons: {
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiPlus,
      mdiClose,
      mdiEye,
      mdiEyeOff,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Novo Usuário' : 'Editar Usuário'
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
    options: {
      handler() {
        this.initialize()
      },
    },
  },

  created() {
    this.initialize()
    this.getRoles().then(response => {
      this.itemsRoles = response.data
    })
  },

  methods: {
    ...mapActions('user', ['getAll', 'store', 'update', 'delete', 'getRoles']),
    initialize() {
      this.loadingTable = true

      const { page, itemsPerPage } = this.options

      const payload = {
        itemsPerPage: itemsPerPage || 10,
        page,
        search: this.search,
      }

      this.getAll(payload)
        .then(response => {
          this.users = response.data.data
          this.totalStagesPaginate = response.data.total
          this.numberOfPagesPaginate = response.data.last_page
          this.currentPagePaginate = response.data.current_page
        })
        .finally(() => {
          this.loadingTable = false
        })
    },

    editItem(item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = { ...item }
      this.dialog = true
    },

    deleteItem(item) {
      this.dialogDelete = true
      this.editedItem = item
    },

    deleteItemConfirm() {
      const index = this.users.indexOf(this.editedItem)
      this.delete(this.editedItem)
        .then(() => {
          this.users.splice(index, 1)
          this.closeDelete()
          this.$toast.success('Excluido com sucesso !')
        })
        .catch()
        .finally()
    },

    close() {
      this.dialog = false
      this.showPassword = false
      this.showPasswordConfirmation = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
      })
    },

    save() {
      this.loading = true
      if (this.editedIndex > -1) {
        const index = this.editedIndex
        this.update(this.editedItem)
          .then(response => {
            const role = response.data
            Object.assign(this.users[index], role)
            this.close()
            this.$toast.success('Salvo com sucesso !')
          })
          .catch()
          .finally(() => {
            this.loading = false
          })
      } else {
        this.store(this.editedItem)
          .then(response => {
            const role = response.data
            this.users.push(role)
            this.close()
            this.$toast.success('Salvo com sucesso !')
          })
          .catch()
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>
